export default __webpack_public_path__ + "static/media/movipack_feature4.6bfe1d28.svg";